module.exports = SharedDependencies.ReactDOM['task-hub'];